/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, {
  Fragment,
  memo,
  useMemo,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import classNames from 'classnames';
import $ from 'jquery';
import _, { debounce } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Types } from 'mongoose';
import ReactTooltip from 'react-tooltip';

import './index.scss';

import { deleteItem } from '../../../util/builder/items';
import MenuVariaveis from '../../MenuVariaveis';
import Carousel from '../../Carousel';
import ConfirmDialog from '../../Header/ConfirmDialog';

import iconRandomTextOff from '../../../assets/images/ic_random.svg';
import iconRandomTextOn from '../../../assets/images/ic_random_act.svg';
import iconError from '../../../assets/images/icone_advertencia.svg';
import iconGroupBuilder from '../../../assets/images/icon_group_builder.svg';
import iconGroupBuilderOver from '../../../assets/images/icon_group_builder_over.svg';
import iconRedirect from '../../../assets/images/icon_direcionador.svg';
import iconRedirectOver from '../../../assets/images/icon_direcionador_over.svg';
import iconGroupBuilderClicked from '../../../assets/images/icon_group_builder_clicked.svg';
import iconRedirectClicked from '../../../assets/images/icon_direcionador_clicked.svg';

import { BotsCreators } from '../../../store/actions/bots';
import { IaCreators } from '../../../store/actions/intelligence';
import { ItemsCreators } from '../../../store/actions/items';
import { ConnectorsCreators } from '../../../store/actions/connectors';
import { validateSquareInfo } from './square-validate';
import * as BotCreatorActions from '../../../store/actions/bot-creator';
import { itemIconDoubleClick } from '../utils';

import SquareVoicebot from './SquareVoicebot';
import OptionsMenuAI from './OptionsMenuAI/index';

import Menu from './Menu';

const imgErrorStyle = {
  filter:
    'invert(56%) sepia(35%) saturate(6030%) hue-rotate(330deg) brightness(99%) contrast(90%)',
};

const Square = (props) => {
  const {
    activateCreate,
    updateSelectedItem,
    item,
    currentClickItem,
    connectors,
    hoveredItem,
    showRightMenu,
    editItem,
    editFile,
    editUrlBlur,
    isCreating,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
    onMouseEnter,
    onMouseLeave,
    cloneItem,
    bot,
    user,
    deleteConnectorRequest,
    itemsOnError,
    zoomLevel,
    setInicialGroupPosition,
    handleMenuOptionHighLight,
    menuOptionLinked,
    currentPath,
  } = props;

  const { i18n } = useTranslation();
  const [isValid, setIsValid] = useState(true);
  const [squareValidate, setSquareValidate] = useState({});
  const [isOpenMenuOptions, setIsOpenMenuOptions] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isMenuContainerHighLigth, setIsMenuContainerHighLigth] =
    useState(null);

  const actionButtonRef = useRef(null);

  let menuItemIndex = 0;

  if (item.type === 'Document') {
    const extensionPattern = /(?:\.([^.]+))?$/;
    item.extension = `.${extensionPattern.exec(item.fileUrl)[1]}`;
  }

  const [question, setQuestion] = useState([]);
  const [itemData, setItemData] = useState({});

  const handleOutsideClick = useCallback((e) => {
    if (actionButtonRef.current !== e.target) {
      setIsOpenMenuOptions(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('click', handleOutsideClick, false);

    return () => {
      window.removeEventListener('click', handleOutsideClick, false);
    };
  }, [handleOutsideClick]);

  useEffect(() => {
    if (item) {
      setItemData(item);

      const { getQueueAttendance } = props;

      if (item.type === 'Form' && item.questions) {
        setQuestion(item.questions);
      }

      if (item.type === 'Human')
        getQueueAttendance({ botId: bot._id, loading: false });
    }

    return () => setItemData({});
  }, [item, bot._id]);

  const handleCloseConfirmModal = () => {
    setModalIsOpen(false);
  };

  const handleConfirmDelete = () => {
    deleteItem(props);
    setModalIsOpen(false);
  };

  const updateSquareOnError = (hasSquareValidate) => {
    const isValidItem = hasSquareValidate.validate({
      bot,
      item: itemData,
      connectors,
    });

    if (!isValidItem) {
      const hasItemOnArray = itemsOnError.find(
        (element) => element._id === item._id
      );

      if (!hasItemOnArray) {
        const { _id, type } = item;
        const { errorListTitle } = hasSquareValidate;

        const { setItemsOnError } = props;

        const newElement = { _id, type, title: errorListTitle, botId: bot._id };
        const newItemsOnError = [...itemsOnError, newElement];

        setItemsOnError(newItemsOnError);
      }

      setSquareValidate(hasSquareValidate);
    } else {
      const { removeItemsOnError } = props;
      removeItemsOnError(item._id);
      setSquareValidate({});
    }

    setIsValid(isValidItem);
  };

  useEffect(() => {
    if (bot && itemData) {
      const hasSquareValidate = validateSquareInfo.find(
        (element) => element.type === itemData.type
      );
      if (hasSquareValidate) {
        updateSquareOnError(hasSquareValidate);
      }
    }
  }, [itemData, connectors]);

  const handleEditItemWithDebounce = useRef(
    debounce((updatedItem) => {
      editItem(updatedItem);
    }, 600)
  ).current;

  const doUpdateItemWithDebounce = (payload) => {
    const updatedItem = { ...itemData, ...payload };
    setItemData(updatedItem);
    handleEditItemWithDebounce(updatedItem);
  };

  const doUpdateItem = (payload) => {
    const updatedItem = { ...itemData, ...payload };
    setItemData(updatedItem);
    editItem(updatedItem);
  };

  const editTitle = (value) => {
    doUpdateItemWithDebounce({ title: value });
  };

  const editVoiceItemDescrition = (value) => {
    doUpdateItemWithDebounce({
      ...itemData,
      voiceSettings: { ...itemData?.voiceSettings, deIvrStep: value },
    });
  };

  const activeCreateMenuConnection = (e, menuItem) => {
    itemData.activeMenuItem = menuItem;
    updateSelectedItem(itemData);
    activateCreate(e, itemData);
  };
  // region - Description

  const activeRandomText = () => {
    if (!itemData.randomTextActive) {
      doUpdateItem({
        randomTextActive: true,
        description: [...itemData.description, ''],
      });
    } else {
      doUpdateItem({
        randomTextActive: false,
        description: [itemData.description[0]],
      });
    }
  };

  const addText = () => {
    if (itemData.description.length <= 4) {
      doUpdateItem({ description: [...itemData.description, ''] });
    }
  };

  const removeText = (e, index) => {
    if (itemData.description.length > 1) {
      const descriptions = itemData.description.filter(
        (desc, i) => index !== i
      );
      doUpdateItem({ description: descriptions });
    }
  };

  const editItemDescription = (e, index) => {
    const temp = itemData.description;
    temp[index] = e.target.value;

    doUpdateItemWithDebounce({ description: temp });
  };

  const handleSelectVariavel = (variavel, index) => {
    const descriptions = itemData.description;
    const oldDescription = descriptions[index];

    descriptions[index] = `${oldDescription.trim()} {${variavel}}`;
    doUpdateItem({ description: descriptions });
  };

  // region - MENU ITEM
  const addMenuItem = () => {
    if (itemData.menuItems.length <= 29) {
      doUpdateItem({
        menuItems: [
          ...itemData.menuItems,
          {
            _id: Types.ObjectId().toString(),
            description: '',
            child: null,
          },
        ],
      });
    }
  };

  const updateMenuItem = (e, menuItem) => {
    doUpdateItemWithDebounce({
      menuItems: itemData.menuItems.map((elem) =>
        elem._id !== menuItem._id
          ? elem
          : { ...menuItem, description: e.target.value }
      ),
    });
  };

  const removeMenuItem = (e, menuItem) => {
    if (itemData.menuItems.length > 1) {
      const connector = connectors.find(
        (connector) => connector.from === menuItem._id
      );
      if (connector) deleteConnectorRequest(connector._id, bot._id);
      doUpdateItem({
        menuItems: itemData.menuItems.filter(
          (elem) => elem._id !== menuItem._id
        ),
      });
    }
  };

  const handleDeleteItem = (event) => {
    event.stopPropagation();
    setIsOpenMenuOptions(false);

    if (props.item.type.toLowerCase() === 'group') {
      setModalIsOpen(true);
    } else {
      deleteItem(props);
    }
  };

  const handleCloneItem = (event, item) => {
    event.stopPropagation();
    setIsOpenMenuOptions(false);

    cloneItem(
      itemData,
      $(event.target).closest('.builder__square').outerWidth()
    );
  };

  const menuHighlight = useMemo(() => {
    return connectors.filter((connector) => connector.to === currentClickItem);
  }, [connectors, currentClickItem]);

  const itemCanHaveTwoConnectors = useMemo(() => {
    const itemsWithTwoConnectors = [
      'ZendeskCreateRequest',
      'ZendeskListRequests',
      'ZendeskShowRequest',
      'ZendeskListComments',
      'ZendeskInsertComment',
      'ZendeskAttachFile',
      'ZendeskUpdateStatusRequest',
      'VTexCatalogProducts',
      'VTexCatalogProduct',
      'VTexAddToCart',
      'VTexRemoveFromCart',
      'VTexCartProduct',
      'VTexUpdateCart',
    ];

    if (itemsWithTwoConnectors.includes(itemData.type)) {
      return (
        connectors.filter((connector) => connector.from === itemData._id)
          .length >= 2
      );
    }
    return true;
  }, [connectors, itemData._id, itemData.type]);

  const itemHasConnectorLimit = useMemo(() => {
    const noConnectorLimitItems = [
      'Conditional',
      'VTexCatalogProducts',
      'VTexCatalogProduct',
      'VTexAddToCart',
      'VTexRemoveFromCart',
      'VTexCartProduct',
      'VTexUpdateCart',
      'JiraCreateIssue',
      'JiraListIssues',
      'JiraShowIssue',
      'JiraListProjects',
      'JiraListPriorities',
      'JiraListStatus',
      'JiraListRequestypes',
      'JiraListComments',
      'JiraInsertComment',
      'JiraAttachFile',
      'JiraUpdateStatusIssue',
    ];
    const isVoiceItem = itemData?.type?.startsWith('Voice');

    return !noConnectorLimitItems.includes(itemData.type) && !isVoiceItem;
  }, [itemData.type]);

  const isConnectorFromItem = useMemo(() => {
    return connectors.some((connector) => connector.from === itemData._id);
  }, [connectors, itemData._id]);

  const isDisabledButtonConnector = useMemo(() => {
    return (
      (user && user?.selectedCompany?.claim?.name === 'Viewer') ||
      isCreating ||
      (isConnectorFromItem && itemCanHaveTwoConnectors && itemHasConnectorLimit)
    );
  }, [
    user,
    isCreating,
    isConnectorFromItem,
    itemCanHaveTwoConnectors,
    itemHasConnectorLimit,
  ]);

  const getErrorBallonText = () => {
    return (
      <Fragment>
        {squareValidate.message}
        <br />
        <a
          href={squareValidate.linkKnowMore}
          target="_blank"
          rel="noopener noreferrer"
        >
          saiba mais
        </a>
      </Fragment>
    );
  };

  const renderSquareActionTopRight = () => {
    if (isValid) {
      return (
        <Fragment>
          <div className="action-dot" />
          <div className="action-dot" />
          <div className="action-dot" />
        </Fragment>
      );
    }
    return (
      <div className="action-error">
        <img
          src={iconError}
          data-for={`BlockError${item._id}`}
          data-tip
          alt="Block Error Warning"
        />
        <ReactTooltip
          id={`BlockError${item._id}`}
          className="error-ballon"
          class="error-ballon"
          place="top"
          effect="solid"
          clickable
          offset={{ top: -10 }}
          overridePosition={(
            { left, top },
            currentEvent,
            currentTarget,
            node
          ) => {
            const documentNode = document.documentElement;
            left =
              Math.min(documentNode.clientWidth - node.clientWidth, left) /
              zoomLevel;
            top =
              Math.min(documentNode.clientHeight - node.clientHeight, top) /
              zoomLevel;
            left = Math.max(0, left);
            top = Math.max(0, top);
            return { top, left };
          }}
        >
          <span>{getErrorBallonText()}</span>
        </ReactTooltip>
      </div>
    );
  };

  const changeSquareIcon = (id, icon) => {
    const img = document.getElementById(id);
    if (img) {
      img.src = icon;
    }
  };

  const onDoubleClickItemIcon = () => {
    const action = itemIconDoubleClick[itemData.type];
    if (action) {
      const options = {
        ...props,
        botId: bot?._id,
        zoomLevel: bot?.viewPosition?.zoomLevel || 1.0,
        item,
        groupTrigger: setInicialGroupPosition,
      };
      action(options);
      showRightMenu(undefined, undefined);
    }
  };

  const isCurrentItemClicked = () => {
    return currentClickItem && currentClickItem === itemData._id;
  };

  const renderCustomSquareIcon = (
    className,
    icon,
    iconOver,
    iconClicked = null
  ) => {
    if (isCurrentItemClicked()) {
      const id = `square-icon-${itemData.type}`;
      return (
        <img
          id={id}
          src={iconClicked || icon}
          alt=""
          className={className}
          onDoubleClick={() => {
            onDoubleClickItemIcon();
          }}
          onMouseOver={() => {
            changeSquareIcon(id, iconOver);
          }}
          onMouseLeave={() => {
            changeSquareIcon(id, iconClicked || icon);
          }}
        />
      );
    }
    return (
      <img id="square-icon-group" src={icon} className={className} alt="" />
    );
  };

  const renderDuplicateSquareOption = () => {
    const { type } = itemData;
    if (type === 'Group') {
      return false;
    }
    return (
      <div
        className="action"
        style={{ marginBottom: -7 }}
        onClick={(event) => handleCloneItem(event, itemData)}
      >
        <img
          src="/assets/images/icons/icon_copiar.svg"
          className="img-fluid"
          alt=""
        />{' '}
        Duplicar
      </div>
    );
  };

  const isPrimary = () => {
    return (
      currentClickItem === itemData._id ||
      menuOptionLinked.to === itemData._id ||
      currentPath?.to === itemData._id ||
      currentPath?.from === itemData._id ||
      isMenuContainerHighLigth === itemData._id
    );
  };

  return (
    <>
      <Fragment key={itemData?._id}>
        <div
          className={classNames({
            builder__square: true,
            'builder__square--primary': isPrimary(),
            'builder__square--hovered':
              isCreating && hoveredItem && hoveredItem._id === itemData._id,
            'builder__square--error': !isValid,
            'builder__square--advanced': [
              'Collect',
              'API',
              'APIV2',
              'SMS',
              'EMAIL',
              'Script',
              'Module',
              'Human',
              'Conditional',
              'Script',
              'Module',
              'DynamicMedia',
              'VTexAddToCart',
              'VTexUpdateCart',
              'VTexRemoveFromCart',
              'VTexOrderList',
              'VTexCartProduct',
              'VTexCatalogProduct',
              'VTexCatalogProducts',
              'VTexCheckout',
              'ZendeskCreateRequest',
              'ZendeskListRequests',
              'ZendeskShowRequest',
              'ZendeskListComments',
              'ZendeskInsertComment',
              'ZendeskAttachFile',
              'ZendeskUpdateStatusRequest',
              'VoiceWebservice',
              'Group',
              'Redirect',
              'BotTransfer',
              'JiraCreateIssue',
              'JiraShowIssue',
              'JiraListIssues',
              'JiraListProjects',
              'JiraListStatus',
              'JiraListRequestypes',
              'JiraListPriorities',
              'JiraListComments',
              'JiraInsertComment',
              'JiraAttachFile',
              'JiraUpdateStatusIssue',
              'RdStationInput',
              'RdStationSubmitLead',
              'GlpiCreateRequest',
              'GlpiListRequests',
              'GlpiShowRequest',
              'GlpiListComments',
              'GlpiInsertComment',
              'GlpiAttachFile',
              'GlpiUpdateStatusRequest',
              'GlpiListGroups',
            ].includes(itemData.type),
            'builder__square--advanced--conditional--hover':
              currentClickItem === itemData._id &&
              ['Conditional', 'Script', 'Module'].includes(itemData.type),
          })}
          onClick={(e) =>
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? showRightMenu(e, itemData)
              : ''
          }
          onMouseEnter={(e) =>
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? onMouseEnter(e, itemData)
              : ''
          }
          onMouseOver={(e) =>
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? onMouseEnter(e, itemData)
              : ''
          }
          onMouseLeave={(e) =>
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? onMouseLeave(e, itemData)
              : ''
          }
        >
          <span>
            {(itemData.type === 'JiraCreateIssue' ||
              itemData.type === 'JiraShowIssue' ||
              itemData.type === 'JiraListIssues' ||
              itemData.type === 'JiraListComments' ||
              itemData.type === 'JiraInsertComment' ||
              itemData.type === 'JiraAttachFile' ||
              itemData.type === 'JiraUpdateStatusIssue' ||
              itemData.type === 'JiraListProjects' ||
              itemData.type === 'JiraListStatus' ||
              itemData.type === 'JiraListPriorities' ||
              itemData.type === 'JiraListRequestypes') && (
              <img
                className="img-item-integracao-bloco"
                alt=""
                src={require('../../../assets/images/jira_icon.png')}
              />
            )}

            {(itemData.type === 'ZendeskCreateRequest' ||
              itemData.type === 'ZendeskListRequests' ||
              itemData.type === 'ZendeskShowRequest' ||
              itemData.type === 'ZendeskListComments' ||
              itemData.type === 'ZendeskInsertComment' ||
              itemData.type === 'ZendeskAttachFile' ||
              itemData.type === 'ZendeskUpdateStatusRequest') && (
              <img
                className="img-item-integracao-bloco"
                alt=""
                src={require('../../../assets/images/zendesk_icon.png')}
              />
            )}

            {(itemData.type === 'GlpiCreateRequest' ||
              itemData.type === 'GlpiListRequests' ||
              itemData.type === 'GlpiShowRequest' ||
              itemData.type === 'GlpiListComments' ||
              itemData.type === 'GlpiInsertComment' ||
              itemData.type === 'GlpiAttachFile' ||
              itemData.type === 'GlpiUpdateStatusRequest' ||
              itemData.type === 'GlpiListGroups') && (
              <img
                className="img-item-integracao-bloco"
                alt=""
                src={require('../../../assets/images/glpi_icon.png')}
              />
            )}

            {(itemData.type === 'RdStationInput' ||
              itemData.type === 'RdStationSubmitLead') && (
              <img
                className="img-item-integracao-bloco"
                alt=""
                src={require('../../../assets/images/rd-station.jpeg')}
              />
            )}

            {(itemData.type === 'VTexAddToCart' ||
              itemData.type === 'VTexUpdateCart' ||
              itemData.type === 'VTexRemoveFromCart' ||
              itemData.type === 'VTexOrderList' ||
              itemData.type === 'VTexCartProduct' ||
              itemData.type === 'VTexCatalogProduct' ||
              itemData.type === 'VTexCheckout' ||
              itemData.type === 'VTexCatalogProducts') && (
              <img
                className="img-item-integracao-bloco"
                alt=""
                src={require('../../../assets/images/vTex_icon.png')}
              />
            )}

            {itemData?.type?.startsWith('Voice') ? (
              <input
                disabled={
                  !!(user && user.selectedCompany?.claim?.name === 'Viewer')
                }
                className={classNames('block-name', {
                  'block-name--error':
                    itemData.voiceSettings?.deIvrStep?.trim() ===
                    'Digite a descrição',
                })}
                type="text"
                value={itemData.voiceSettings?.deIvrStep}
                onChange={(e) => editVoiceItemDescrition(e.target.value)}
                id={`voice-item-description-${itemData?._id}`}
              />
            ) : (
              <input
                disabled={
                  !!(user && user.selectedCompany?.claim?.name === 'Viewer')
                }
                className="block-name"
                type="text"
                maxLength={30}
                value={itemData.title}
                onChange={(e) => editTitle(e.target.value)}
                id={`item-title-${itemData?._id}`}
              />
            )}

            {(itemData.type === 'Text' || itemData.type === 'Menu') &&
              (currentClickItem === itemData._id ||
                itemData.randomTextActive) && (
                <img
                  className={`pointer action-random-text ${
                    itemData.randomTextActive
                      ? 'action-random-text-active '
                      : ''
                  }${
                    currentClickItem === itemData._id &&
                    itemData.randomTextActive
                      ? 'action-random-text-selected'
                      : ''
                  }`}
                  src={
                    itemData.randomTextActive
                      ? iconRandomTextOn
                      : iconRandomTextOff
                  }
                  onClick={
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? activeRandomText
                      : ''
                  }
                  alt=""
                />
              )}
            <div
              className="actions"
              onClick={() => setIsOpenMenuOptions(!isOpenMenuOptions)}
              ref={actionButtonRef}
            >
              {renderSquareActionTopRight()}
              <div
                className={classNames({
                  'd-none': !isOpenMenuOptions,
                  'actions-box': true,
                })}
              >
                <div className="arrow-up" />
                {renderDuplicateSquareOption()}
                <div className="action" onClick={handleDeleteItem}>
                  <img
                    src="/assets/images/icons/icon-delete.svg"
                    className="img-fluid"
                    alt=""
                  />{' '}
                  Excluir
                </div>
              </div>
            </div>
          </span>

          {itemData.type === 'Video' && (
            <div className="container-video-square">
              {itemData.fileUrl && (
                <div
                  className={classNames({
                    'd-none': itemData.uploading,
                  })}
                >
                  <video
                    preload="auto"
                    controls
                    className={classNames({
                      'd-none': !itemData.thumbnailUrl && itemData.uploading,
                      'video-preview': true,
                      'img-fluid': true,
                    })}
                  >
                    <source src={itemData.fileUrl} type="video/mp4" />
                  </video>
                  <div
                    className="remove-content-button video-content"
                    onClick={(e) => editFile(e, itemData)}
                  >
                    <img src="/assets/images/icons/icon_delete_document.svg" />
                    <div>Remover Vídeo</div>
                  </div>
                </div>
              )}
              <div
                className={classNames({
                  'd-none': !itemData.uploading,
                  'text-center': true,
                  uploading: true,
                })}
              >
                <div
                  className="progress-circle"
                  data-progress={itemData.upload_progress}
                />
                fazendo o upload
              </div>
              {!itemData.thumbnailUrl && (
                <label
                  className={classNames({
                    'builder__square--upload-container': true,
                    'd-none': itemData.uploading,
                  })}
                  htmlFor={`${itemData._id}_upload`}
                  onDragEnter={(e) =>
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? onDragEnter(e)
                      : ''
                  }
                  onDragLeave={(e) =>
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? onDragLeave(e)
                      : ''
                  }
                  onDragOver={(e) =>
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? onDragOver(e)
                      : ''
                  }
                  onDrop={(e) =>
                    user?.selectedCompany?.claim?.name !== 'Viewer'
                      ? onDrop(e, itemData)
                      : ''
                  }
                >
                  {itemData.thumbnail_url && (
                    <img src={itemData.thumbnail_url} alt="" />
                  )}
                  <input
                    disabled={
                      !!(user?.selectedCompany?.claim?.name === 'Viewer')
                    }
                    type="file"
                    id={`${itemData._id}_upload`}
                    data-id={itemData._id}
                    accept="video/mp4"
                    onChange={(e) => editFile(e, itemData)}
                    style={{
                      display: `none`,
                    }}
                  />

                  <img
                    src="/assets/images/icons/video-holder.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <div className="square-texto-video" data-id={itemData._id}>
                    Clique aqui, arraste um vídeo ou cole a URL do arquivo para
                    upload
                  </div>
                  <div className="input-group">
                    <img
                      src="/assets/images/icons/icon_link.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      disabled={
                        !!(user?.selectedCompany?.claim?.name === 'Viewer')
                      }
                      type="text"
                      placeholder="URL"
                      onBlur={(e) => editUrlBlur(e, itemData)}
                      onFocus={(e) => (e.oldValue = e.target.value)}
                    />
                  </div>
                </label>
              )}
            </div>
          )}

          {itemData.type === 'Image' && (
            <div className="square-container-img">
              <div
                className={classNames({
                  'd-none': !itemData.thumbnailUrl || itemData.uploading,
                })}
              >
                <img
                  srcSet={itemData.thumbnailUrl}
                  className={classNames({
                    'img-fluid': true,
                    'img-preview': true,
                  })}
                  alt=""
                />
                <div
                  className="remove-content-button video-content"
                  onClick={(e) => editFile(e, itemData)}
                >
                  <img src="/assets/images/icons/icon_delete_document.svg" />
                  <div>Remover Imagem</div>
                </div>
              </div>
              <div
                className={classNames({
                  'd-none': !itemData.uploading,
                  'text-center': true,
                  uploading: true,
                })}
              >
                <div
                  className="progress-circle"
                  data-progress={itemData.upload_progress}
                />
                fazendo o upload
              </div>
              {!itemData.thumbnailUrl && (
                <label
                  style={{ width: '230px' }}
                  className={classNames({
                    'builder__square--upload-container': true,
                    'd-none': itemData.uploading,
                  })}
                  htmlFor={`${itemData._id}_upload`}
                  onDragEnter={(e) => onDragEnter(e)}
                  onDragLeave={(e) => onDragLeave(e)}
                  onDragOver={(e) => onDragOver(e)}
                  onDrop={(e) => onDrop(e, itemData)}
                >
                  {itemData.thumbnail_url && (
                    <img src={itemData.thumbnail_url} alt="" />
                  )}
                  <input
                    disabled={
                      !!(user?.selectedCompany?.claim?.name === 'Viewer')
                    }
                    type="file"
                    id={`${itemData._id}_upload`}
                    data-id={itemData._id}
                    accept=".jpg, .jpeg, .png, .gif, .bmp"
                    onChange={(e) => editFile(e, itemData)}
                    style={{
                      display: `none`,
                    }}
                  />

                  <img
                    src="/assets/images/icons/image-holder.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <div className="square-texto-img" data-id={itemData._id}>
                    Clique aqui, arraste uma imagem ou cole URL para upload
                  </div>
                  <div className="input-group">
                    <img
                      src="/assets/images/icons/icon_link.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      disabled={
                        !!(user?.selectedCompany?.claim?.name === 'Viewer')
                      }
                      type="text"
                      placeholder="URL"
                      onBlur={(e) => editUrlBlur(e, itemData)}
                      onFocus={(e) => (e.oldValue = e.target.value)}
                    />
                  </div>
                </label>
              )}
            </div>
          )}

          {itemData.type === 'Carousel' && (
            <div className="square-container-img">
              {itemData.carousel.cards && !!itemData.carousel.cards.length ? (
                <div style={{ marginTop: '36px' }}>
                  <Carousel carouselData={itemData.carousel} />
                </div>
              ) : (
                <label
                  style={{ width: '230px' }}
                  className="builder__square--upload-container"
                >
                  {itemData.thumbnail_url && (
                    <img src={itemData.thumbnail_url} alt="" />
                  )}

                  <img
                    src="/assets/images/icons/icon_carrossel_cinza.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <div className="square-texto-img" data-id={itemData._id}>
                    Crie cards para seu carrossel no menu lateral
                  </div>
                </label>
              )}
            </div>
          )}

          {itemData.type === 'Document' && (
            <div className="container-document-square">
              <div
                className={classNames({
                  'd-none':
                    !itemData.fileUrl ||
                    itemData.uploading ||
                    itemData.thumbnailUrl,
                  'img-fluid': true,
                  'document-preview': true,
                })}
              >
                <img
                  src="/assets/images/icons/document-preview.svg"
                  className={classNames({ 'img-fluid': true })}
                  alt=""
                />
                <span>{itemData.extension}</span>
                <div
                  className="remove-content-button"
                  onClick={(e) => editFile(e, itemData)}
                >
                  <img src="/assets/images/icons/icon_delete_document.svg" />
                  <div>Remover Documento</div>
                </div>
              </div>

              <img
                src={itemData.thumbnailUrl}
                className={classNames({
                  'd-none': !itemData.thumbnailUrl,
                  'img-fluid': true,
                  'document-pdf-preview': true,
                })}
                alt=""
              />

              <div
                className={classNames({
                  'd-none': !itemData.uploading,
                  'text-center': true,
                  uploading: true,
                })}
              >
                <div
                  className="progress-circle"
                  data-progress={itemData.upload_progress}
                />
                fazendo o upload
              </div>
              {!itemData.fileUrl && (
                <label
                  className={classNames({
                    'builder__square--upload-container': true,
                    'd-none': itemData.uploading,
                  })}
                  htmlFor={`${itemData._id}_upload`}
                  onDragEnter={(e) => onDragEnter(e)}
                  onDragLeave={(e) => onDragLeave(e)}
                  onDragOver={(e) => onDragOver(e)}
                  onDrop={(e) => onDrop(e, itemData)}
                >
                  {itemData.thumbnail_url && (
                    <img src={itemData.thumbnail_url} alt="" />
                  )}
                  <input
                    disabled={
                      !!(user?.selectedCompany?.claim?.name === 'Viewer')
                    }
                    type="file"
                    id={`${itemData._id}_upload`}
                    data-id={itemData._id}
                    accept=".doc, .docx, .xls, .xlsx, .txt, .pdf, .csv, .ppt, .pptx"
                    onChange={(e) => editFile(e, itemData)}
                    style={{
                      display: `none`,
                    }}
                  />

                  <img
                    src="/assets/images/icons/document-holder.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <div className="square-texto-document" data-id={itemData._id}>
                    Clique aqui, arraste um documento ou cole URL para upload
                  </div>
                  <div className="input-group">
                    <img
                      src="/assets/images/icons/icon_link.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      disabled={
                        !!(user?.selectedCompany?.claim?.name === 'Viewer')
                      }
                      type="text"
                      placeholder="URL"
                      onBlur={(e) => editUrlBlur(e, itemData)}
                      onFocus={(e) => (e.oldValue = e.target.value)}
                    />
                  </div>
                </label>
              )}
            </div>
          )}

          {itemData.type === 'Audio' && (
            <div className="container-audio-square">
              {itemData.fileUrl && (
                <div
                  className={classNames({
                    'd-none': itemData.uploading || !itemData.fileUrl,
                  })}
                >
                  <div
                    className={classNames({
                      'audio-preview': true,
                    })}
                  >
                    <audio
                      controls
                      style={{ width: '100%', height: '25px' }}
                      controlsList="nofullscreen nodownload noremoteplayback foobar"
                    >
                      <source src={itemData.fileUrl} type="audio/mp3" />
                      <source src={itemData.fileUrl} type="audio/mpga" />
                    </audio>
                  </div>
                  <div
                    className="remove-content-button video-content"
                    onClick={(e) => editFile(e, itemData)}
                  >
                    <img src="/assets/images/icons/icon_delete_document.svg" />
                    <div>Remover Áudio</div>
                  </div>
                </div>
              )}

              <div
                className={classNames({
                  'd-none': !itemData.uploading,
                  'text-center': true,
                  uploading: true,
                })}
              >
                <div
                  className="progress-circle"
                  data-progress={itemData.upload_progress}
                />
                fazendo o upload
              </div>

              {!itemData.fileUrl && (
                <label
                  className={classNames({
                    'builder__square--upload-container': true,
                    'd-none': itemData.uploading,
                  })}
                  htmlFor={`${itemData._id}_upload`}
                  onDragEnter={(e) => onDragEnter(e)}
                  onDragLeave={(e) => onDragLeave(e)}
                  onDragOver={(e) => onDragOver(e)}
                  onDrop={(e) => onDrop(e, itemData)}
                >
                  {itemData.thumbnail_url && (
                    <img src={itemData.thumbnail_url} alt="" />
                  )}

                  <img
                    src="/assets/images/icons/audio-holder.svg"
                    className="img-fluid"
                    alt=""
                  />
                  <div className="square-texto-video" data-id={itemData._id}>
                    Clique aqui, arraste um áudio ou cole a URL do arquivo para
                    upload
                  </div>
                  <div className="input-group">
                    <img
                      src="/assets/images/icons/icon_link.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <input
                      disabled={
                        !!(user?.selectedCompany?.claim?.name === 'Viewer')
                      }
                      type="text"
                      placeholder="URL"
                      onBlur={(e) => editUrlBlur(e, itemData)}
                      onFocus={(e) => (e.oldValue = e.target.value)}
                    />
                  </div>

                  <input
                    disabled={
                      !!(user?.selectedCompany?.claim?.name === 'Viewer')
                    }
                    type="file"
                    id={`${itemData._id}_upload`}
                    data-id={itemData._id}
                    accept=".mp3, .wav, .oga, .ogg, .mpga"
                    onChange={(e) => editFile(e, itemData)}
                    style={{
                      display: `none`,
                    }}
                  />
                </label>
              )}
            </div>
          )}

          {itemData.type === 'Menu' && (
            <Menu
              itemData={itemData}
              handleSelectVariavel={handleSelectVariavel}
              currentClickItem={currentClickItem}
              editItemDescription={editItemDescription}
              user={user}
              updateMenuItem={updateMenuItem}
              addText={addText}
              menuItemIndex={menuItemIndex}
              removeMenuItem={removeMenuItem}
              menuHighlight={menuHighlight}
              addMenuItem={addMenuItem}
              removeText={removeText}
              isCreating={isCreating}
              connectors={connectors}
              activeCreateMenuConnection={activeCreateMenuConnection}
              doUpdateItemWithDebounce={doUpdateItemWithDebounce}
              handleMenuOptionHighLight={handleMenuOptionHighLight}
              currentPath={currentPath}
              setIsMenuContainerHighLigth={setIsMenuContainerHighLigth}
            />
          )}

          {itemData.type === 'Text' && (
            <div className="container-out-square-text">
              <div className="container-square-text">
                {itemData.description.map((value, index) => (
                  <div
                    className="form-group container-btn-remove"
                    key={`desc-${index}-${itemData._id}`}
                  >
                    <MenuVariaveis
                      onSelect={(variavel) =>
                        handleSelectVariavel(variavel, index)
                      }
                      id={`bloco-${itemData._id}`}
                      buttonRight="12px"
                    >
                      <textarea
                        id={`desc-${index}-${itemData._id}`}
                        key={`desc-${index}-${itemData._id}`}
                        data-id={`desc-${index}-${itemData._id}`}
                        value={value}
                        placeholder="Descrição..."
                        onChange={(e) => editItemDescription(e, index)}
                        maxLength={300}
                      />
                    </MenuVariaveis>
                    {currentClickItem === itemData._id &&
                      itemData.randomTextActive && (
                        <button
                          type="button"
                          disabled={
                            !!(user?.selectedCompany?.claim?.name === 'Viewer')
                          }
                          className="action-random-text-remove-button"
                          id={`btnRemoveItem-${index}-${itemData._id}`}
                          style={{
                            opacity: currentClickItem === itemData._id ? 1 : 0,
                            cursor:
                              currentClickItem === itemData._id
                                ? 'pointer'
                                : 'default',
                          }}
                          onClick={(e) => {
                            currentClickItem === itemData._id
                              ? removeText(e, index)
                              : e.preventDefault();
                          }}
                        >
                          <img
                            src={require('../../../assets/images/icon_delete_red.svg')}
                            alt=""
                          />
                        </button>
                      )}
                  </div>
                ))}
              </div>

              <div className="container-square-menu-addButton-text">
                {itemData.randomTextActive && (
                  <button
                    type="button"
                    disabled={
                      !!(user?.selectedCompany?.claim?.name === 'Viewer')
                    }
                    className="action-random-text-add-button"
                    style={{
                      display:
                        currentClickItem === itemData._id ? 'flex' : 'none',
                      cursor:
                        currentClickItem === itemData._id
                          ? 'pointer'
                          : 'default',
                    }}
                    onClick={(e) => {
                      currentClickItem === itemData._id
                        ? addText()
                        : e.preventDefault();
                    }}
                  >
                    <img
                      src={require('../../../assets/images/ic_plus_white.svg')}
                      alt=""
                    />
                  </button>
                )}
              </div>
            </div>
          )}

          {itemData.type === 'Form' && (
            <div className="container-out-square-text">
              <div className="container-square-text">
                {itemData?.description.map((value, index) => (
                  <div
                    className="form-group container-btn-remove barra-questions-container"
                    key={`desc-${index}-${itemData._id}`}
                  >
                    {question.map((qt, questionIndex) => (
                      <textarea
                        id={`desc-${questionIndex}-${itemData._id}`}
                        key={`desc-${questionIndex}-${itemData._id}`}
                        data-id={`desc-${questionIndex}-${itemData._id}`}
                        disabled
                        value={qt.question}
                        placeholder="Descrição..."
                        maxLength={300}
                        style={{ marginBottom: 8 }}
                      />
                    ))}
                    {currentClickItem === itemData._id &&
                      itemData.randomTextActive && (
                        <button
                          type="button"
                          className="action-random-text-remove-button"
                          id={`btnRemoveItem-${index}-${itemData._id}`}
                          style={{
                            opacity: currentClickItem === itemData._id ? 1 : 0,
                            cursor:
                              currentClickItem === itemData._id
                                ? 'pointer'
                                : 'default',
                          }}
                          onClick={(e) => {
                            currentClickItem === itemData._id
                              ? removeText(e, index)
                              : e.preventDefault();
                          }}
                        >
                          <img
                            src={require('../../../assets/images/icon_delete_red.svg')}
                            alt=""
                          />
                        </button>
                      )}
                  </div>
                ))}
              </div>
              {itemData.randomTextActive && (
                <button
                  type="button"
                  className="action-random-text-add-button"
                  style={{
                    display:
                      currentClickItem === itemData._id ? 'flex' : 'none',
                    cursor:
                      currentClickItem === itemData._id ? 'pointer' : 'default',
                  }}
                  onClick={(e) => {
                    currentClickItem === itemData._id
                      ? addText()
                      : e.preventDefault();
                  }}
                >
                  <img
                    src={require('../../../assets/images/ic_plus_white.svg')}
                    alt=""
                  />
                </button>
              )}
            </div>
          )}

          {itemData.type === 'Collect' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/ic_coleta.svg')}
                alt="Coleta"
                style={isValid ? {} : imgErrorStyle}
              />
              <span className="advanced-name">{i18n.t('Bloco de coleta')}</span>
            </div>
          )}

          {itemData.type === 'Conditional' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_condicional.svg')}
                alt="conditional"
              />
              <span className="advanced-name p-6">
                {i18n.t('Bloco Condicional')}
              </span>
            </div>
          )}

          {itemData.type === 'API' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_json.svg')}
                alt="api"
              />
              <span className="advanced-name">{i18n.t('Bloco JSON API')}</span>
            </div>
          )}

          {itemData.type === 'APIV2' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_json.svg')}
                alt="apiV2"
              />
              <span className="advanced-name">{i18n.t('Bloco API V2')}</span>
            </div>
          )}

          {itemData.type === 'SMS' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_chat.svg')}
                alt="sms"
                style={isValid ? {} : imgErrorStyle}
              />
              <span className="advanced-name">{i18n.t('Bloco de SMS')}</span>
            </div>
          )}

          {itemData.type === 'EMAIL' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_email.svg')}
                alt="email"
                style={isValid ? {} : imgErrorStyle}
              />
              <span className="advanced-name">{i18n.t('Bloco de Email')}</span>
            </div>
          )}

          {itemData.type === 'Script' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_script.svg')}
                alt="script"
              />
              <span className="advanced-name p-6">
                {i18n.t('Bloco de script')}
              </span>
            </div>
          )}

          {itemData.type === 'Module' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_modulo.svg')}
                alt="module"
              />
              <span className="advanced-name p-6">
                {i18n.t('Bloco de Módulo')}
              </span>
            </div>
          )}

          {itemData.type === 'Human' && (
            <div className="advanced-square-wrapper">
              <img
                alt=""
                src={require('../../../assets/images/humano.svg')}
                style={isValid ? {} : imgErrorStyle}
              />
              <span className="advanced-name p-6">
                {i18n.t('Bloco Humano')}
              </span>
            </div>
          )}

          {itemData.type === 'DynamicMedia' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/midia_dinamica.svg')}
                alt="script"
              />
              <span className="advanced-name">Mídia Dinâmica</span>
            </div>
          )}

          {itemData.type === 'Group' && (
            <div className="advanced-square-wrapper">
              {renderCustomSquareIcon(
                'square-border-group',
                iconGroupBuilder,
                iconGroupBuilderOver,
                iconGroupBuilderClicked
              )}
              <span className="square-group-length">
                {itemData.subflowLength || 0}
              </span>
              <span className="advanced-name">Grupo</span>
            </div>
          )}

          {itemData.type === 'Redirect' && (
            <div className="advanced-square-wrapper">
              {renderCustomSquareIcon(
                isCurrentItemClicked() ? 'square-border-redirect' : '',
                iconRedirect,
                iconRedirectOver,
                iconRedirectClicked
              )}
              <span
                className={`advanced-name ${
                  isCurrentItemClicked() ? '' : 'redirect-span'
                }`}
              >
                Direcionador
              </span>
            </div>
          )}

          {itemData.type === 'BotTransfer' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_bot_transfer.svg')}
                style={{ width: 30, height: 30 }}
                alt="script"
              />
              <span className="advanced-name">Transferência de Bot</span>
            </div>
          )}

          {itemData.type === 'VTexAddToCart' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_adicionar_ao_carrinho.svg')}
                alt="script"
              />
              <span className="advanced-name">Adicionar ao carrinho VTex</span>
            </div>
          )}

          {itemData.type === 'VTexUpdateCart' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_atualizar_carrinho.svg')}
                alt="script"
              />
              <span className="advanced-name">Atualizar carrinho VTex</span>
            </div>
          )}

          {itemData.type === 'VTexRemoveFromCart' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_remover_item_carrinho.svg')}
                alt="script"
              />
              <span className="advanced-name">
                Remover item do carrinho VTex
              </span>
            </div>
          )}

          {itemData.type === 'VTexOrderList' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_listar_carrinho.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar carrinho VTex</span>
            </div>
          )}

          {itemData.type === 'VTexCatalogProduct' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_buscar_produto_catalogo.svg')}
                alt="produto"
              />
              <span className="advanced-name">
                Buscar produto do catálogo VTex
              </span>
            </div>
          )}

          {itemData.type === 'VTexCatalogProducts' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_listar_catalogo.svg')}
                alt="Listar produtos"
              />
              <span className="advanced-name">Listar Catálogo VTex</span>
            </div>
          )}

          {itemData.type === 'VTexCartProduct' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_buscar_produto_carrinho.svg')}
                alt="Buscar produto do carrinho"
              />
              <span className="advanced-name">
                Buscar produto do carrinho VTex
              </span>
            </div>
          )}

          {itemData.type === 'MenuAI' && (
            <div className="container-out-square-text">
              <div className="container-square-text">
                {itemData.description.map((value, index) => (
                  <div
                    className="form-group container-btn-remove"
                    key={`desc-${index}-${itemData._id}`}
                  >
                    <MenuVariaveis
                      onSelect={(variavel) =>
                        handleSelectVariavel(variavel, index)
                      }
                      id={`bloco-${itemData._id}`}
                      buttonRight="12px"
                    >
                      <textarea
                        className="textarea"
                        id={`desc-${index}-${itemData._id}`}
                        key={`desc-${index}-${itemData._id}`}
                        data-id={`desc-${index}-${itemData._id}`}
                        value={value}
                        placeholder="Descrição..."
                        onChange={(e) => editItemDescription(e, index)}
                        maxLength={300}
                      />
                    </MenuVariaveis>
                    {currentClickItem === itemData._id &&
                      itemData.randomTextActive && (
                        <button
                          type="button"
                          disabled={!!(user && user.claim.name === 'Viewer')}
                          className="action-random-text-remove-button"
                          id={`btnRemoveItem-${index}-${itemData._id}`}
                          style={{
                            opacity: currentClickItem === itemData._id ? 1 : 0,
                            cursor:
                              currentClickItem === itemData._id
                                ? 'pointer'
                                : 'default',
                          }}
                          onClick={(e) => {
                            currentClickItem === itemData._id
                              ? removeText(e, index)
                              : e.preventDefault();
                          }}
                        >
                          <img
                            src={require('../../../assets/images/icon_delete_red.svg')}
                            alt=""
                          />
                        </button>
                      )}
                  </div>
                ))}
              </div>

              <div className="container-square-menu">
                <div className="container-square-menu-addButton">
                  {currentClickItem === itemData._id &&
                    itemData.randomTextActive && (
                      <button
                        type="button"
                        disabled={!!(user && user.claim.name === 'Viewer')}
                        className="action-random-text-add-button"
                        onClick={addText}
                      >
                        <img
                          src={require('../../../assets/images/ic_plus_white.svg')}
                          alt=""
                        />
                      </button>
                    )}
                </div>

                <div className="div-block-menu-item">
                  {itemData.menuItems.map((menuItem) => {
                    return (
                      <div
                        className="container-remove-button-item"
                        key={`block-menu=item-dot-${menuItemIndex++}-${
                          itemData._id
                        }`}
                      >
                        <button
                          type="button"
                          disabled={!!(user && user.claim.name === 'Viewer')}
                          id={`block-menu=item-dot-${menuItemIndex++}-${
                            itemData._id
                          }`}
                          className="block-menu-item-minus"
                          onClick={(e) => removeMenuItem(e, menuItem)}
                        >
                          <img
                            src={require('../../../assets/images/icon_delete_red.svg')}
                            alt=""
                          />
                        </button>

                        <div
                          className={`block-menu-item block-p-menu ${
                            menuHighlight.some(
                              (menuItemH) => menuItem._id === menuItemH.from
                            )
                              ? 'block-menu-item-highlight'
                              : ''
                          }`}
                          key={`block-menu-item-key-${menuItemIndex++}-${
                            itemData._id
                          }`}
                        >
                          <OptionsMenuAI
                            itemData={itemData}
                            token={props.bot.currentTokenIa}
                            listIntent={props.listIAIntents}
                            menuItem={menuItem}
                            doUpdateItemWithDebounce={doUpdateItemWithDebounce}
                            editItem={editItem}
                            debounce={debounce}
                            handleEditItemWithDebounce={
                              handleEditItemWithDebounce
                            }
                            setItemData={setItemData}
                          />
                          <button
                            type="button"
                            disabled={!!(user && user.claim.name === 'Viewer')}
                            id={`block-menu=item-dot-${menuItemIndex++}-${
                              itemData._id
                            }`}
                            className="block-menu-item-dot"
                            disabled={
                              isCreating ||
                              connectors.some(
                                (connector) => connector.from === menuItem._id
                              )
                            }
                            onClick={(e) =>
                              activeCreateMenuConnection(e, menuItem)
                            }
                          >
                            <i />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="container-block-menu-item-add">
                  <button
                    type="button"
                    disabled={!!(user && user.claim.name === 'Viewer')}
                    className="block-menu-item-add"
                    onClick={addMenuItem}
                  >
                    <img
                      src={require('../../../assets/images/add_botao.svg')}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          )}

          {itemData.type === 'VTexCheckout' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_checkout.svg')}
                alt="script"
              />
              <span className="advanced-name">Checkout VTex</span>
            </div>
          )}

          {itemData.type === 'ZendeskCreateRequest' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_create_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Criar novo Ticket</span>
            </div>
          )}

          {itemData.type === 'ZendeskListRequests' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_list_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Tickets</span>
            </div>
          )}

          {itemData.type === 'ZendeskShowRequest' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Checar Ticket</span>
            </div>
          )}

          {itemData.type === 'ZendeskListComments' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_list_comment.svg')}
                alt="produto"
              />
              <span className="advanced-name">Listar Comentários</span>
            </div>
          )}

          {itemData.type === 'ZendeskInsertComment' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_insert_comment.svg')}
                alt="Listar produtos"
              />
              <span className="advanced-name">Inserir Comentário</span>
            </div>
          )}

          {itemData.type === 'ZendeskAttachFile' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_attach_file.svg')}
                alt="Buscar produto do carrinho"
              />
              <span className="advanced-name">Anexar Arquivo</span>
            </div>
          )}

          {itemData.type === 'ZendeskUpdateStatusRequest' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/resolver.svg')}
                alt="script"
              />
              <span className="advanced-name">Finalizar Ticket</span>
            </div>
          )}

          {itemData.type === 'JiraCreateIssue' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_create_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Criar novo Ticket</span>
            </div>
          )}

          {itemData.type === 'JiraListIssues' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_list_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Tickets</span>
            </div>
          )}

          {itemData.type === 'JiraShowIssue' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Checar Ticket</span>
            </div>
          )}

          {itemData.type === 'JiraListProjects' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Projetos</span>
            </div>
          )}

          {itemData.type === 'JiraListStatus' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Status</span>
            </div>
          )}

          {itemData.type === 'JiraListRequestypes' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Tipos de tickets</span>
            </div>
          )}

          {itemData.type === 'JiraListPriorities' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Prioridades</span>
            </div>
          )}

          {itemData.type === 'JiraListComments' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_insert_comment.svg')}
                alt="Listar comentarios"
              />
              <span className="advanced-name">Listar Comentários</span>
            </div>
          )}

          {itemData.type === 'JiraInsertComment' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_insert_comment.svg')}
                alt="inserir comentarios"
              />
              <span className="advanced-name">Inserir Comentário</span>
            </div>
          )}

          {itemData.type === 'JiraAttachFile' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_attach_file.svg')}
                alt="inserir anexo ao ticket"
              />
              <span className="advanced-name">Anexar Arquivo</span>
            </div>
          )}

          {itemData.type === 'JiraUpdateStatusIssue' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/resolver.svg')}
                alt="Atualiza status do ticket"
              />
              <span className="advanced-name">Finalizar Ticket</span>
            </div>
          )}

          {itemData.type === 'RdStationInput' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icone_campo_rd.svg')}
                alt="Campo de informação"
              />
              <span className="advanced-name">Campo</span>
            </div>
          )}

          {itemData.type === 'RdStationSubmitLead' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icone_criar_lead.svg')}
                alt="Criar lead"
              />
              <span className="advanced-name">Criar Lead</span>
            </div>
          )}

          {itemData.type === 'GlpiCreateRequest' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_create_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Criar novo Ticket</span>
            </div>
          )}

          {itemData.type === 'GlpiListRequests' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_list_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Tickets</span>
            </div>
          )}

          {itemData.type === 'GlpiShowRequest' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_show_request-1.svg')}
                alt="script"
              />
              <span className="advanced-name">Checar Ticket</span>
            </div>
          )}

          {itemData.type === 'GlpiListComments' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_list_comment.svg')}
                alt="produto"
              />
              <span className="advanced-name">Listar Comentários</span>
            </div>
          )}

          {itemData.type === 'GlpiInsertComment' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_insert_comment.svg')}
                alt="Listar produtos"
              />
              <span className="advanced-name">Inserir Comentário</span>
            </div>
          )}

          {itemData.type === 'GlpiAttachFile' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_attach_file.svg')}
                alt="Buscar produto do carrinho"
              />
              <span className="advanced-name">Anexar Arquivo</span>
            </div>
          )}

          {itemData.type === 'GlpiUpdateStatusRequest' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/resolver.svg')}
                alt="script"
              />
              <span className="advanced-name">Finalizar Ticket</span>
            </div>
          )}

          {itemData.type === 'GlpiListGroups' && (
            <div className="advanced-square-wrapper">
              <img
                src={require('../../../assets/images/icon_list_request.svg')}
                alt="script"
              />
              <span className="advanced-name">Listar Grupos</span>
            </div>
          )}

          {itemData.type?.startsWith('Voice') && (
            <SquareVoicebot
              item={itemData}
              activeCreateMenuConnection={activeCreateMenuConnection}
              menuHighlight={menuHighlight}
              isCreating={isCreating}
              connectors={connectors}
              addMenuItem={addMenuItem}
              removeMenuItem={removeMenuItem}
              updateMenuItem={updateMenuItem}
              updateItemWithDebounce={doUpdateItemWithDebounce}
            />
          )}

          {currentClickItem === itemData._id &&
            itemData.type !== 'Menu' &&
            itemData.type !== 'MenuAI' &&
            itemData.type !== 'Carousel' &&
            itemData.type !== 'VoiceTTSAudioDTMF' &&
            itemData.type !== 'VoiceTTSAudioASR' &&
            itemData.type !== 'VoiceWebApiList' &&
            !itemData.lockConnectorFrom && (
              <button
                disabled={isDisabledButtonConnector}
                onClick={(e) => activateCreate(e, itemData)}
                type="button"
                className="button-connector"
              >
                <i className="arrow down" />
              </button>
            )}
        </div>
      </Fragment>

      <ConfirmDialog
        title="Confirmar exclusão"
        body="Você tem certeza que deseja excluir o bloco de grupo? Todo fluxo que está dentro do bloco será perdido."
        show={modalIsOpen}
        handleClose={handleCloseConfirmModal}
        onConfirm={handleConfirmDelete}
      >
        Deseja realmente deletar o bloco?
      </ConfirmDialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  itemsToRemove: state.items.itemsToRemove,
  bot: state.bots.bot,
  user: state.users.signedUser,
  connectorsOnError: state.botCreator.connectorsOnError,
  itemsOnError: state.botCreator.itemsOnError,
  debounceList: state.debounce.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...ItemsCreators,
      ...BotsCreators,
      ...ConnectorsCreators,
      ...BotCreatorActions,
      ...IaCreators,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(memo(Square));
